import { withBreakpointObserver } from '@studiometa/js-toolkit';
import { Slider, SliderBtn, SliderDrag, SliderItem } from '@studiometa/ui';

/**
 * Class
 */
export default class ButtonsSlider extends withBreakpointObserver(Slider) {
  /**
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    ...Slider.config,
    name: 'ButtonsSlider',
    components: {
      SliderDrag,
      SliderItem,
      SliderBtn,
    },
  };

  /**
   * Mounted.
   * @returns {void}
   */
  mounted() {
    this.changeMode();
    super.mounted();
  }

  /**
   * Resized.
   * @param {import('@studiometa/js-toolkit').ResizeServiceProps} props
   * @returns {void}
   */
  resized(props) {
    this.changeMode();
    super.resized(props);
  }

  /**
   * Change mode.
   * @returns {void}
   */
  changeMode() {
    if (window.innerWidth < 768) {
      this.$options.mode = 'center';
      this.$options.contain = false;
    } else {
      this.$options.mode = 'left';
      this.$options.contain = true;
    }
  }
}
